
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    Grid,
    Paper,
    TextField,
    Typography,
    CircularProgress,
    
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab';
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from '../../../assets/globalStyles';
import { gruppe } from '../../../utils/apiTypes';
import { rollen, isAuthorized } from "../../../utils/auth/authConfig";
import {
    selectSelectedGruppe,
    setSelectedGruppe,
    emptyGruppe,
    selectGruppen,
    deleteGruppe,
    selectGruppentypen,
    selectGruppeLoading,
    setNewMode,
    setEditMode,
    selectEditMode,
    selectNewMode
} from './gruppenverwaltungSlice';
import { useStyles } from './gruppenverwaltungStyles';

export const Gruppenauswahl: React.FC = () => {
    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const selectedGruppe = useAppSelector(selectSelectedGruppe);
    const gruppen = useAppSelector(selectGruppen);
    const gruppentypen = useAppSelector(selectGruppentypen);
    const gruppenLoading = useAppSelector(selectGruppeLoading);
    const newMode = useAppSelector(selectNewMode);
    const editMode = useAppSelector(selectEditMode);

    const [gruppeSelectInputValue, setGruppeSelectInputValue] = React.useState("");
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

    const gruppeLoeschen = (gruppe: gruppe) => {
        setOpenDeleteDialog(false);
        dispatch(deleteGruppe(gruppe));
    }

    return (
        <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
            <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                <Grid item md={3} >
                    <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "12px" }} >
                        Gruppe auswählen
                    </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={6} style={{ paddingRight: "24px" }}>
                    <Grid item container md={12} >
                        <Grid item md={3} />
                        <Grid item md={3} style={{ paddingLeft: "10px" }} >
                            {isAuthorized([rollen.admin, rollen.netzwirtschaft, rollen.technik]) ?
                                [ (selectedGruppe.name != '' && !editMode) && !newMode ?
                                <Button
                                    variant="contained"
                                    onClick={() => setOpenDeleteDialog(true)}
                                    color="secondary"
                                    style={{ width: "100%" }}
                                    className={`${classes.backgroundColorErrorDark} ${classes.showButton}`}
                                >
                                    Löschen
                                </Button> : "" ]
                                : ""}
                            <Dialog
                                open={openDeleteDialog}
                                onClose={() => setOpenDeleteDialog(false)}
                            >
                                <DialogTitle>Gruppe löschen</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        {'Sind Sie sicher, dass Sie die Gruppe "' +
                                            selectedGruppe.name +
                                            '" wirklich löschen wollen? Alle Messstellenzuordnungen werden ebenfalls gelöscht.'}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        onClick={() => setOpenDeleteDialog(false)}
                                        className={classes.cancleDeleteButton}
                                    >
                                        Abbrechen
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => gruppeLoeschen(selectedGruppe)}
                                        className={classes.confirmDeleteButton}
                                        style={{ minWidth: "120px", minHeight: "36px" }}
                                    >
                                        {gruppenLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Grid>
                        <Grid item md={3} style={{ paddingLeft: "10px" }}>
                            {isAuthorized([rollen.admin, rollen.netzwirtschaft, rollen.technik]) ?
                                <Button
                                    variant="contained"
                                    onClick={() => dispatch(setEditMode(true))}
                                    disabled={selectedGruppe.id === 0 || editMode || newMode}
                                    color="secondary"
                                    style={{ width: "100%" }}
                                    className={classes.showButton}
                                >
                                    Bearbeiten
                                </Button>
                                : ""}
                        </Grid>
                        <Grid item md={3} style={{ paddingLeft: "10px" }}>
                            {isAuthorized([rollen.admin, rollen.technik, rollen.netzwirtschaft]) ?
                                <Button
                                    variant="contained"
                                    onClick={() => dispatch(setNewMode(true))}
                                    color="secondary"
                                    className={classes.showButton}
                                    disabled={editMode || newMode}
                                    style={{ width: "100%" }}
                                >
                                    Neue Gruppe
                                </Button>
                                : ""}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={2} style={{ marginBottom: "20px", paddingRight: "24px" }}>
                <Grid item md={12} style={{ paddingLeft: "0px", paddingRight: "10px" }}>
                    <FormControl className={[classes.formControl, classes.fullWidth].join(' ')} style={{ paddingLeft: "8px" }}>
                        <Autocomplete
                            id="select-gruppe"
                            value={selectedGruppe}
                            noOptionsText={<React.Fragment>
                                {gruppenLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Gruppen"}</React.Fragment>
                            }
                            onChange={(event, newValue) => {
                                newValue ?
                                    dispatch(setSelectedGruppe(newValue))
                                    :
                                    dispatch(setSelectedGruppe(emptyGruppe))
                            }}
                            inputValue={gruppeSelectInputValue}
                            onInputChange={(event, newInputValue) => setGruppeSelectInputValue(newInputValue)}
                            options={gruppen}
                            getOptionLabel={(option: gruppe) => (option && option.typ ? option.name + " (" + gruppentypen.find(x => x.id == option.typ)?.name + ")" : "")}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Gruppe"
                                    variant="outlined"
                                />
                            )}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </Paper>
    );
}
